/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiV5FirmsFileNamingTemplates200,
  PutApiV5FirmsFileNamingTemplatesId200,
  PutApiV5FirmsFileNamingTemplatesId422,
  PutApiV5FirmsFileNamingTemplatesIdBody
} from '.././schemas'
import getApiV5FirmsFileNamingTemplatesMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FirmsFileNamingTemplatesErrorType } from '../../configOrvalAPIV5';
import putApiV5FirmsFileNamingTemplatesIdMutator from '../../configOrvalAPIV5';
import type { ErrorType as PutApiV5FirmsFileNamingTemplatesIdErrorType } from '../../configOrvalAPIV5';



/**
 * Returns the effective template for each document type, showing firm-specific overrides where they exist and system defaults otherwise
 * @summary List effective file naming templates for the current firm
 */
export const getApiV5FirmsFileNamingTemplates = (
    
 signal?: AbortSignal
) => {
      
      
      return getApiV5FirmsFileNamingTemplatesMutator<GetApiV5FirmsFileNamingTemplates200>(
      {url: `/api/v5/firms/file_naming_templates`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FirmsFileNamingTemplatesQueryKey = () => {
    return [`/api/v5/firms/file_naming_templates`] as const;
    }

    
export const getGetApiV5FirmsFileNamingTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>, TError = GetApiV5FirmsFileNamingTemplatesErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FirmsFileNamingTemplatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>> = ({ signal }) => getApiV5FirmsFileNamingTemplates(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FirmsFileNamingTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>>
export type GetApiV5FirmsFileNamingTemplatesQueryError = GetApiV5FirmsFileNamingTemplatesErrorType<unknown>


/**
 * @summary List effective file naming templates for the current firm
 */

export function useGetApiV5FirmsFileNamingTemplates<TData = Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>, TError = GetApiV5FirmsFileNamingTemplatesErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsFileNamingTemplates>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FirmsFileNamingTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates or updates a firm-specific template override for a document type. Use __all__ as the document type for a firm-wide default.
 * @summary Create or update a firm-specific file naming template
 */
export const putApiV5FirmsFileNamingTemplatesId = (
    id: string,
    putApiV5FirmsFileNamingTemplatesIdBody: PutApiV5FirmsFileNamingTemplatesIdBody,
 ) => {
      
      
      return putApiV5FirmsFileNamingTemplatesIdMutator<PutApiV5FirmsFileNamingTemplatesId200>(
      {url: `/api/v5/firms/file_naming_templates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putApiV5FirmsFileNamingTemplatesIdBody
    },
      );
    }
  


export const getPutApiV5FirmsFileNamingTemplatesIdMutationOptions = <TError = PutApiV5FirmsFileNamingTemplatesIdErrorType<PutApiV5FirmsFileNamingTemplatesId422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsFileNamingTemplatesId>>, TError,{id: string;data: PutApiV5FirmsFileNamingTemplatesIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsFileNamingTemplatesId>>, TError,{id: string;data: PutApiV5FirmsFileNamingTemplatesIdBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV5FirmsFileNamingTemplatesId>>, {id: string;data: PutApiV5FirmsFileNamingTemplatesIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV5FirmsFileNamingTemplatesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV5FirmsFileNamingTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV5FirmsFileNamingTemplatesId>>>
    export type PutApiV5FirmsFileNamingTemplatesIdMutationBody = PutApiV5FirmsFileNamingTemplatesIdBody
    export type PutApiV5FirmsFileNamingTemplatesIdMutationError = PutApiV5FirmsFileNamingTemplatesIdErrorType<PutApiV5FirmsFileNamingTemplatesId422>

    /**
 * @summary Create or update a firm-specific file naming template
 */
export const usePutApiV5FirmsFileNamingTemplatesId = <TError = PutApiV5FirmsFileNamingTemplatesIdErrorType<PutApiV5FirmsFileNamingTemplatesId422>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsFileNamingTemplatesId>>, TError,{id: string;data: PutApiV5FirmsFileNamingTemplatesIdBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiV5FirmsFileNamingTemplatesId>>,
        TError,
        {id: string;data: PutApiV5FirmsFileNamingTemplatesIdBody},
        TContext
      > => {

      const mutationOptions = getPutApiV5FirmsFileNamingTemplatesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    